<template>
  <svg class="flex-shrink-0" :class="size" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="9" width="3" height="5" rx="1" :class="option.level >= 1 ? option.barColor : 'fill-gray-200 dark:fill-gray-700'"/>
    <rect x="6.5" y="6" width="3" height="8" rx="1" :class="option.level >= 2 ? option.barColor : 'fill-gray-200 dark:fill-gray-700'"/>
    <rect x="12" y="2" width="3" height="12" rx="1" :class="option.level >= 3 ? option.barColor : 'fill-gray-200 dark:fill-gray-700'"/>
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { CRITICALITY_OPTIONS } from 'controllers/vue_components/organizations/applications/applicationOptions.js'

const props = defineProps({
  criticality: { type: String, required: true },
  size: { type: String, default: 'w-3.5 h-3.5' },
})

const option = computed(() => CRITICALITY_OPTIONS.find((o) => o.value === props.criticality) || CRITICALITY_OPTIONS[1])
</script>
